/**
 * Minimal tracking-consent switch for analytics / ad tags.
 *
 * Rumio ships no consent banner; a storefront that adds one calls
 * `grantTrackingConsent()` / `revokeTrackingConsent()`. Tags whose settings
 * say "require consent" stay silent until granted. Stored per browser.
 */

export const TRACKING_CONSENT_KEY = 'rumio_tracking_consent';

export function trackingConsentGranted(): boolean {
  try {
    return localStorage.getItem(TRACKING_CONSENT_KEY) === 'granted';
  } catch {
    return false;
  }
}

export function setTrackingConsent(granted: boolean): void {
  try {
    localStorage.setItem(TRACKING_CONSENT_KEY, granted ? 'granted' : 'denied');
  } catch {
    /* storage blocked */
  }
}
